<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
          <span class='traveller'>Traveller</span>{{ $t('technical_support') }}:<i class="nc-icon nc-email-85"></i><a :href="'mailto:' + footerEmail">{{ footerEmail }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
import settings from '@/store/system/settings'

export default {
  beforeCreate() {
    if (!this.$store.state.settings) {
      this.$store.registerModule("settings", settings);
    }
    this.$store.dispatch('settings/getSettingsList');
  },
  computed: {
    footerEmail() {
      return this.$store.getters['settings/getSetting']('UI_FOOTER_EMAIL');
    }
  }
}
</script>
<style>
.copyright i {
  margin-left: 10px;
  margin-right: 5px;
}
</style>
